import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {UmpireVenue} from '@tisa-group/models';

@Injectable()
export class VenueService implements CrudService<UmpireVenue> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireVenue[]>> {
    return this.http
      .get(`/venues`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/venues/${id}`);
  }

  create(
    body: Partial<UmpireVenue>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireVenue>> {
    return this.http
      .post('/venues', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireVenue>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireVenue>> {
    return this.http
      .patch<JsonApiResponse<UmpireVenue>>(
        `/venues/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }
}
